export enum TrafficTemplateAlias {
    OVERALL_CHANGE = "overall-change",
    CHANGE_BY_MARKETING_CHANNEL = "change-by-marketing-channel",
    ENGAGEMENT = "engagement",
    NEW_MARKETS = "new-markets",
}
